import i18n from "@/lib/i18n";

// Player-facing API errors → text in the current (= game) language.
// Coded details ({code, message, …}) use errors.<code>; known plain-English
// server strings are mapped to a key; anything else falls back to the server text.
const EXACT = {
  "Game is not currently open": "game_not_open",
  "Lottery is not currently open": "game_not_open",
  "Game not found": "game_not_found",
  "Phone number required": "phone_required",
  "City required": "city_required",
  "Number of children required": "children_required",
  "Name required": "name_required",
  "Predictions closed (a match has already started)": "predictions_closed",
  "Session not found": "session_not_found",
  "Quiz session not found": "session_not_found",
  "One answer set per question is required": "quiz_incomplete",
  "Invalid score": "score_rejected",
  "Score exceeds plausible maximum": "score_rejected",
  "Invalid game duration": "score_rejected",
  "Invalid slice count": "score_rejected",
  "Score inconsistent with slices": "score_rejected",
  "Score inconsistent with duration": "score_rejected",
  "Tap count too low for score": "score_rejected",
  "Claim not found": "claim_not_found",
  "Invalid price guess": "invalid_input",
  "Invalid end reason": "invalid_input",
  "Invalid day": "invalid_input",
};
const PREFIX = [
  ["Required CTAs not completed", "ctas_missing"],
  ["Missing prediction for match", "pred_missing"],
  ["Invalid score for match", "invalid_input"],
  ["Invalid winner for match", "invalid_input"],
];

function keyForString(s) {
  if (EXACT[s]) return EXACT[s];
  const hit = PREFIX.find(([p]) => s.startsWith(p));
  if (hit) return hit[1];
  if (/déjà particip|already participated/i.test(s)) return "already_participated";
  return null;
}

function tr(key, params, fallback) {
  const k = `errors.${key}`;
  return i18n.exists(k) ? i18n.t(k, params) : fallback;
}

export function playerErrorMessage(err, fallback) {
  const d = err?.response?.data?.detail;
  if (d && typeof d === "object" && !Array.isArray(d)) {
    const params = { ...d };
    if (params.min_amount != null) params.min_amount = Number(params.min_amount).toFixed(2);
    return tr(d.code, params, d.message || fallback || i18n.t("errors.generic"));
  }
  if (typeof d === "string") {
    const key = keyForString(d);
    return key ? tr(key, {}, d) : d;
  }
  if (Array.isArray(d)) return i18n.t("errors.invalid_input");
  return fallback || i18n.t("errors.generic");
}
